import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AvatarService } from '@services/avatar.service';
import { UploadService } from '@services/upload.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-newavatar',
  templateUrl: './newavatar.component.html',
  styleUrls: ['./newavatar.component.css']
})
export class NewavatarComponent implements OnInit {

  definitionForm:FormGroup;
  submitted=false;
  @Input() data:any;
  constructor(
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private languageService:AvatarService,
    private toastrService:ToastrService,
     private uploadService:UploadService) { }

  ngOnInit() {
    this.definitionForm=this.formBuilder.group({
      'name':['',Validators.required],
      'url':['',Validators.required],
      
    });

    if(this.data){

        this.definitionForm.get("name").patchValue(this.data.name);
        this.definitionForm.get("url").patchValue(this.data.url);
     
       
    }
    
  }



  save(){

    if(!this.definitionForm.valid){
      this.definitionForm.markAllAsTouched();
      this.toastrService.clear();
      this.toastrService.warning("Lütfen gerekli alanları doldurunuz","Uyarı");
      return;
    }
    this.submitted=true;

    if(this.data){

      this.languageService.update(this.data.id,this.definitionForm.value).subscribe(res=>{

        this.toastrService.clear();
        this.toastrService.success("Avatar güncelleme başarılı","İşlem Başarılı");
        this.definitionForm.reset();
        this.submitted=false;
      },err=>{
        this.submitted=false;
        this.toastrService.clear();
        this.toastrService.error("Kayıt sırasında hata oluştu","Hata");
      });


    }else{
      this.languageService.add(this.definitionForm.value).subscribe(res=>{

        this.toastrService.clear();
        this.toastrService.success("Avatar ekleme başarılı","İşlem Başarılı");
        this.definitionForm.reset();
        this.submitted=false;
      },err=>{
        this.submitted=false;
        this.toastrService.clear();
        this.toastrService.error("Kayıt sırasında hata oluştu","Hata");
      });
    }



  }

  close(){
    this.activeModal.close();
  }


  files: File[] = [];

  SelectSingleFile(event) {
    this.files.push(...event.addedFiles);
   
    if(this.files[0].size>2024000){
      this.toastrService.clear();
      this.toastrService.warning("2 MB'dan büyük dosya yükleyemezsiniz.","Uyarı");
      this.files.splice(this.files.indexOf(event), 1);
      return;
    }
    
  
     let formData=new FormData();
     formData.append('file',this.files[0],this.files[0].name);
      this.uploadService.file(formData,"avatars").subscribe(res=>{
        this.definitionForm.get("url").patchValue(res[0]);
      
      },err=>{
        this.toastrService.clear();
        this.toastrService.error("Görsel yüklenirken bir hata oluştu.","Hata");
        this.files.splice(this.files.indexOf(event), 1);
    
      });
    
  
  }
  
  SinglefileonRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
    this.definitionForm.get("url").patchValue("");
  }

}
